import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import '../assets/css/components/ngss-dimension-table.css'

const NgssDimensionTable = props => {
  const { type, dimensionItems } = props

  const getTypeTitle = ()=> {
    if(type === 'ccc') {
      return 'Cross-Cutting Concepts'
    } else if (type === 'dci') {
      return 'Disciplinary Core Ideas'
    } else if (type === 'sep') {
      return 'Science & Engineering Practices'
    } else {
      return 'Unknown'
    }
  }

  return(
    <div className='ngss-dimension-table'>
      <div className={`dimension-type ${type}`}>
        {getTypeTitle()}
      </div>
      <div className={`dimension-items ${type}`}>
        {_.map(dimensionItems, item =>
          <div key={item.name} className='dimension-item'>
            <div className='item-name'>{item.name}</div>
            <ul>
              {_.map(item.clauses, clause =>
                <li>{clause}</li>
              )}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}

NgssDimensionTable.propTypes = {
  /* Dimension type. Should be either 'ccc', 'dci', or 'sep' */
  type: PropTypes.string.isRequired,
  /* Dimension components (ie, "Developing and Using Models") with their corresponding clauses. */
  dimensionItems: PropTypes.arrayOf(PropTypes.shape(
    {
      name: PropTypes.string,
      clauses: PropTypes.arrayOf(PropTypes.string)
    }))
}

NgssDimensionTable.defaultProps = {
  dimensionTypes: []
}

export default NgssDimensionTable
